import { render } from "./materialView.vue?vue&type=template&id=21fc9d63&scoped=true"
import script from "./materialView.vue?vue&type=script&lang=js"
export * from "./materialView.vue?vue&type=script&lang=js"

import "./materialView.vue?vue&type=style&index=0&id=21fc9d63&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fc9d63"]])

export default __exports__